import { Paper, Table, TableContainer } from '@mui/material'
import { ExpensesDeclarationTableHead } from './ExpensesDeclarationTableHead'
import { ExpensesDeclarationTableBody } from './ExpensesDeclarationTableBody'
import { ExpenseDeclaration } from '@/types'

export type ExpensesDeclarationTableProps = {
  rows: ExpenseDeclaration[]
  showExpenseDeclarationDetails: (id: number) => void
}

export const ExpensesDeclarationTable = ({
  rows,
  showExpenseDeclarationDetails,
}: ExpensesDeclarationTableProps): JSX.Element => (
  <TableContainer component={Paper}>
    <Table stickyHeader={true}>
      <ExpensesDeclarationTableHead />
      <ExpensesDeclarationTableBody
        rows={rows}
        showExpenseDeclarationDetails={showExpenseDeclarationDetails}
      />
    </Table>
  </TableContainer>
)
